/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AttributeOption } from './attributeOption';

export interface Attribute {
  active?: boolean;
  attributeGroupId?: number;
  attributeId?: number;
  attributeName?: string;
  attributeQuestion?: string;
  attributeTypeId?: number;
  dateCreated?: Date;
  dateUpdated?: Date;
  mobileImage?: string;
  options?: Array<AttributeOption>;
  order?: number;
  sensitiveContent?: boolean;
  syncToCustomerIO?: boolean;
  syncronizable?: boolean;
  webImage?: string;
}
